// One root for every key this module owns, so a single invalidation of `all` reaches every
// list (one per customer and filter) and every detail (§8). Generate Orders invalidates
// ['orders'] too, which is this root.
export const ordersQueryKeys = {
    all: ['orders'] as const,
    list: (filter: Record<string, string>) => ['orders', 'list', filter] as const,
    detail: (id?: string) => ['orders', 'detail', id] as const,
};
